import { render } from "./HeadlineSmall.vue?vue&type=template&id=e043504c"
import script from "./HeadlineSmall.vue?vue&type=script&lang=js"
export * from "./HeadlineSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__